var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label,"label-cols":"4","label-align":"right"}},[_c('b-form-checkbox',{staticClass:"mt-2",attrs:{"checked":_vm.value,"switch":""},on:{"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }